import React, { useEffect } from "react";
import { Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import AppBar from "src/components/AppBar/AppBar";
import { IconName } from "src/components/Icon/Icon";
import { IRootState } from "src/store/reducers";
import { fetchApplicationOptions } from "src/store/reducers/applicationBuilder";
import {
  fetchReqDetails,
  fetchReqOptions,
  newRequirement,
  saveReqDetails,
} from "src/store/reducers/applicationRequirements";
import { fetchApplication } from "src/store/reducers/applications";
import * as S from "../../../../../constants/StringConstants";
import RequirementForm from "../RequirementForm/RequirementForm";
import RequirementInfo from "../RequirementInfo/RequirementInfo";

const RequirementDetail = () => {
  const { appID, reqID } = useParams<{ appID: string; reqID: string }>();
  const dispatch = useDispatch();
  const history = useHistory();
  const isNew = reqID === "new";

  const queryParams = new URLSearchParams(location.search);
  const requirementList = queryParams.get("requirementList")?.split(",") || [];
  const requirementListHasMore = queryParams.get("hasMore") !== "true";
  const currentIndex = requirementList.indexOf(reqID);
  const hasNext = !isNew && currentIndex !== -1 && currentIndex < requirementList.length - 1;
  const hasPrev = !isNew && currentIndex !== -1 && currentIndex > 0;

  const makeUrl = id => `/applications/${appID}/requirements/${id}?requirementList=${requirementList.join(",")}`;
  const handlePrev = () => {
    const url = makeUrl(requirementList[currentIndex - 1]);
    history.replace(url);
  };
  const handleNext = () => {
    const nextId = requirementList[currentIndex + 1];
    // !!! hack for now, require use to load next page from list !!!
    if (!nextId && requirementListHasMore) {
      alert("Next item not loaded, please open next page from item list");
      return;
    }
    const url = makeUrl(nextId);
    history.replace(url);
  };

  const { reqDetails, isFetching, appDetails } = useSelector((state: IRootState) => ({
    isFetching: state.applicationRequirements.loading,
    reqDetails: state.applicationRequirements.requirementDetails,
    appDetails: state.applications.map[appID],
  }));

  useEffect(() => {
    (async () => {
      dispatch(fetchApplication(appID));
      dispatch(fetchApplicationOptions());
      if (isNew) {
        await dispatch(fetchReqOptions(appID));
        dispatch(newRequirement());
      } else {
        dispatch(fetchReqDetails(reqID));
      }
    })();
  }, [dispatch, reqID, isNew]);

  const handleSubmit = async (values: any) => {
    const payload = {
      ...values,
      requirementPriority: values.priority ? 1 : 0,
      proposedInsured: `${appDetails?.firstName} ${appDetails?.lastName}`,
    };

    try {
      await dispatch(saveReqDetails(appID, payload));
      history.push(`/applications/${appID}/requirements`);
    } catch (error) {
      alert(`Error: ${error}`);
    }
  };

  return (
    <div className="comments-detail">
      <AppBar icon={IconName.Applications} title={S.APP_REQS_TITLE} loading={isFetching} />
      {!isFetching && (
        <div className="comments-detail__inner-container">
          <RequirementInfo reqDetails={reqDetails} />
          <hr />
          <Form
            initialValues={reqDetails}
            onSubmit={handleSubmit}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <RequirementForm reqDetails={reqDetails} />
                <div className="app-builder__action_buttons">
                  <button
                    disabled={!hasPrev}
                    type="button"
                    className="button-v2 button-v2__secondary"
                    onClick={handlePrev}>
                    {S.APP_REQS_PREV}
                  </button>
                  <button
                    type="button"
                    disabled={!hasNext}
                    className="button-v2 button-v2__secondary"
                    onClick={handleNext}>
                    {S.APP_REQS_NEXT}
                  </button>
                  <button type="button" className="button-v2 button-v2__secondary" onClick={() => history.goBack()}>
                    {S.APP_REQS_ADD_CANCEL}
                  </button>
                  <button type="submit" className="button-v2 button-v2__primary">
                    {S.APP_REQS_ADD_SAVE_CLOSE}
                  </button>
                </div>
              </form>
            )}
          />
        </div>
      )}
    </div>
  );
};

export default RequirementDetail;
